module.exports = __webpack_public_path__ + "img/z_07_carlos-ibanez.ddaf764a.jpg";